import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPlatform: window.sessionStorage.getItem(
    "exchange.search.selectedPlatform"
  )
    ? window.sessionStorage.getItem("exchange.search.selectedPlatform")
    : null,
  selectedPlatformDisplayName: window.sessionStorage.getItem(
    "exchange.search.selectedPlatformDisplayName"
  )
    ? window.sessionStorage.getItem(
        "exchange.search.selectedPlatformDisplayName"
      )
    : null,
  // Flag to track if user explicitly cleared the platform filter
  isPlatformClearedByUser: false,
};

export const platformSlice = createSlice({
  name: "platform",
  initialState,
  reducers: {
    updateSelectedPlatform: (state, action) => {
      state.selectedPlatform = action.payload.type;
      state.selectedPlatformDisplayName = action.payload.displayValue;
      state.isPlatformClearedByUser = false; // Reset flag when user selects a platform
      window.sessionStorage.setItem(
        "exchange.search.selectedPlatform",
        action.payload.type
      );
      window.sessionStorage.setItem(
        "exchange.search.selectedPlatformDisplayName",
        action.payload.displayValue
      );
    },
    resetSelectedPlatform: (state, action) => {
      state.selectedPlatform = null;
      state.selectedPlatformDisplayName = null;
      // Only set isPlatformClearedByUser to true if explicitly passed as payload (user clicked X)
      // Otherwise, preserve the existing flag value (don't reset it on programmatic calls)
      if (action.payload?.clearedByUser === true) {
        state.isPlatformClearedByUser = true;
      }
      // Note: we don't set it to false here - only updateSelectedPlatform resets the flag
      window.sessionStorage.removeItem("exchange.search.selectedPlatform");
      window.sessionStorage.removeItem(
        "exchange.search.selectedPlatformDisplayName"
      );
    },
    // Action to reset the cleared flag (e.g., on page navigation)
    resetPlatformClearedFlag: (state) => {
      state.isPlatformClearedByUser = false;
    },
  },
  extraReducers: (builder) => {},
});

export const { updateSelectedPlatform, resetSelectedPlatform, resetPlatformClearedFlag } =
  platformSlice.actions;

export const selectPlatform = state => state.platform.selectedPlatform;

export default platformSlice.reducer;
